module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldIt.3af2bf2.ttf";